module.exports = __webpack_public_path__ + "static/img/2025-07-06.454fb73c.png";